import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./BrandManagerSidebar.css";
import {
  CLIENT_SUPPORT_HUB_PATH,
  isClientSupportHubPath,
} from "../supportHubPaths";
import {
  BM_ACCOUNT_BASE,
  BM_ACCOUNT_COMPANY,
  BM_ACCOUNT_PAYMENT,
  BM_ACCOUNT_SECURITY,
  BM_USER_MANAGEMENT_ROLES,
  BM_USER_MANAGEMENT_USERS,
  isBrandManagerAccountPath,
  isBrandManagerUserManagementPath,
} from "../brandManagerPaths";
import SidebarExpandableNavLabel from "./SidebarExpandableNavLabel";

const BrandManagerSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [accountExpanded, setAccountExpanded] = useState(false);
  const [userMgmtExpanded, setUserMgmtExpanded] = useState(false);

  const isActive = (path) => location.pathname === path;
  const supportActive = isClientSupportHubPath(location.pathname);
  const accountActive = isBrandManagerAccountPath(location.pathname);
  const userMgmtActive = isBrandManagerUserManagementPath(location.pathname);

  useEffect(() => {
    if (accountActive) setAccountExpanded(true);
    if (userMgmtActive) setUserMgmtExpanded(true);
  }, [accountActive, userMgmtActive]);

  return (
    <div
      className="sidebar brand-manager-sidebar"
      data-testid="brand-manager-sidebar"
    >
      <div
        className="sidebar-scroll-region"
        data-testid="brand-manager-sidebar-scroll"
      >
        <div className="sidebar-heading">Brand Management</div>
        <div
          className={`submenu-item ${isActive("/brand-manager") ? "active" : ""}`}
          onClick={() => navigate("/brand-manager")}
          data-testid="brand-manager-nav-all-brands"
        >
          All Brands
        </div>
        <div
          className={`submenu-item ${isActive("/brand-manager/add-brand") ? "active" : ""}`}
          onClick={() => navigate("/brand-manager/add-brand")}
        >
          Add New Brand
        </div>
        <div
          className={`submenu-item ${isActive("/brand-manager/brand-requests") ? "active" : ""}`}
          onClick={() => navigate("/brand-manager/brand-requests")}
        >
          Brand Requests
        </div>

        <div className="sidebar-heading">Support</div>
        <div
          className={`submenu-item ${supportActive ? "active" : ""}`}
          onClick={() => navigate(CLIENT_SUPPORT_HUB_PATH)}
          data-testid="brand-manager-nav-support"
        >
          Support
        </div>

        <div className="sidebar-heading">Analytics</div>
        <div
          className={`submenu-item ${isActive("/brand-manager/analytics") ? "active" : ""}`}
          onClick={() => navigate("/brand-manager/analytics")}
        >
          Brand Performance
        </div>
        <div
          className={`submenu-item ${isActive("/brand-manager/reports") ? "active" : ""}`}
          onClick={() => navigate("/brand-manager/reports")}
        >
          Reports
        </div>

        <div className="sidebar-heading manage-section">Manage</div>
        <div
          className={`submenu-item account-item ${accountActive ? "active" : ""}`}
          onClick={() => {
            setAccountExpanded((v) => !v);
            setUserMgmtExpanded(false);
            navigate(BM_ACCOUNT_BASE);
          }}
          data-testid="brand-manager-nav-account"
        >
          <SidebarExpandableNavLabel
            label="Account"
            expanded={accountExpanded}
            testId="brand-manager-account-expandable"
          />
        </div>
        {accountExpanded && (
          <div
            className="account-submenu"
            data-testid="brand-manager-account-submenu"
          >
            <div
              className={`submenu-subitem ${
                location.pathname === BM_ACCOUNT_BASE ? "active" : ""
              }`}
              onClick={() => navigate(BM_ACCOUNT_BASE)}
              data-testid="brand-manager-nav-my-profile"
            >
              My Profile
            </div>
            <div
              className={`submenu-subitem ${
                location.pathname.includes("/account/security") ? "active" : ""
              }`}
              onClick={() => navigate(BM_ACCOUNT_SECURITY)}
            >
              Security
            </div>
            <div
              className={`submenu-subitem ${
                location.pathname.includes("/account/company") ? "active" : ""
              }`}
              onClick={() => navigate(BM_ACCOUNT_COMPANY)}
            >
              Company Profile
            </div>
            <div
              className={`submenu-subitem ${
                location.pathname.includes("/account/payment") ? "active" : ""
              }`}
              onClick={() => navigate(BM_ACCOUNT_PAYMENT)}
            >
              Payment Methods
            </div>
          </div>
        )}

        <div
          className={`submenu-item ${userMgmtActive ? "active" : ""}`}
          onClick={() => {
            setUserMgmtExpanded((v) => !v);
            setAccountExpanded(false);
            navigate(BM_USER_MANAGEMENT_USERS);
          }}
          data-testid="brand-manager-nav-user-management"
        >
          <SidebarExpandableNavLabel
            label="User Management"
            expanded={userMgmtExpanded}
            testId="brand-manager-um-expandable"
          />
        </div>
        {userMgmtExpanded && (
          <div className="account-submenu" data-testid="brand-manager-um-submenu">
            <div
              className={`submenu-subitem ${
                location.pathname.includes("/user-management") &&
                !location.pathname.includes("/roles")
                  ? "active"
                  : ""
              }`}
              onClick={() => navigate(BM_USER_MANAGEMENT_USERS)}
            >
              Users
            </div>
            <div
              className={`submenu-subitem ${
                location.pathname.includes("/user-management/roles")
                  ? "active"
                  : ""
              }`}
              onClick={() => navigate(BM_USER_MANAGEMENT_ROLES)}
            >
              Roles
            </div>
          </div>
        )}

        <div className="sidebar-heading">Settings</div>
        <div
          className={`submenu-item ${isActive("/brand-manager/settings") ? "active" : ""}`}
          onClick={() => navigate("/brand-manager/settings")}
        >
          Brand Settings
        </div>
      </div>
    </div>
  );
};

export default BrandManagerSidebar;
